<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import type { PayoutAccountStatus } from '@/types/organisations'

const props = defineProps<{
  status: PayoutAccountStatus
}>()

const { t } = useI18n()

const classes: Record<PayoutAccountStatus, string> = {
  active: 'bg-emerald-500/20 text-emerald-400',
  action_required: 'bg-amber-500/20 text-amber-400',
  pending_verification: 'bg-sky-500/20 text-sky-400',
  incomplete: 'bg-slate-700 text-slate-300',
  not_started: 'bg-slate-700 text-slate-400',
  restricted: 'bg-red-500/20 text-red-400',
}

const label = computed<string>(() => t(`admin.organisations.payout_status.${props.status}`))
</script>

<template>
  <span
    class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium"
    :class="classes[status]"
    :data-payout-status="status"
  >
    {{ label }}
  </span>
</template>
